import { useLocale } from '../useLocale'

const { timeZone } = Intl.DateTimeFormat().resolvedOptions()

const useUserSettings = () => {
  const { country, hourCycle, locale } = useLocale()

  return { country, hourCycle, locale, timeZone }
}

export { useUserSettings }
